<div class="sus-motion list-circle padlist no-list circle-blue">
    <!-- section 1 contents -->
    <div class="sec-1">
        <div class="container">
            <div class="row">
                <!-- title -->
                <div class="col-md-12 my-md-5 mb-5 sec-title">
                    <app-title-page [dataTitle]="dataTitle" [link]="'#sus-policy'"> </app-title-page>
                </div>
                <!-- detail -->
                <div class="col-md-12" id="sus-policy">
                    <div class="lane-top py-5">
                        <div class="row">
                            <div class="col-xl-5 col-lg-6 col-md-8">
                                <h6 class="mini-tit">{{ dataSection[0]?.title }}</h6>
                            </div>
                            <div class="col-md-12">
                                <div class="desc text-justify" [innerHTML]="dataSection[0]?.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="commits">
                        <h6 class="mini-tit">{{ dataSection[1]?.title }}</h6>
                        <div class="desc text-justify" [innerHTML]="dataSection[1]?.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
    <!-- section 2 contents  -->
    <div class="sec-2 mt-5 py-5">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="foundation">
                        <h3 class="title f-mtit mb-4">{{ dataSection[2]?.title }}</h3>
                        <div class="desc text-justify" [innerHTML]="dataSection[2]?.content"></div>
                        <div class="warp-aspect my-md-5 my-4">
                            <div class="row px-md-0 px-4">
                                <div class="col-md-3 py-md-0 p-2 col-6" *ngFor="let aspect of dataAspect">
                                    <app-card-aspect [dataAspect]="aspect"></app-card-aspect>
                                </div>
                            </div>
                        </div>
                        <div class="desc text-justify" [innerHTML]="dataSection[3]?.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- section 3 contents -->
    <div class="sec-3 bg-headline d-flex align-items-center"
        [ngStyle]="{'background-image' : 'url('+ apiAsset + dataSection[4]?.picture +')'}">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-7">
                    <h3>{{ dataSection[4]?.title }}</h3>
                </div>
            </div>
        </div>
    </div>
    <!-- section 4 contents -->
    <div class="sec-4">
        <div class="container warp-1 py-5">
            <div class="row">
                <div class="col-md-12">
                    <div class="desc text-justify" [innerHTML]="dataSection[4]?.content"></div>
                </div>
            </div>
        </div>
        <div class="warp-2 py-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h6 class="mini-tit">{{ dataSection[5]?.title }}</h6>
                        <div class="desc text-justify" [innerHTML]="dataSection[5]?.content"></div>  
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
